import { AfterViewInit, Component, ElementRef, OnInit, viewChild, ViewEncapsulation } from '@angular/core';
import { BaseSelectionControl } from "../base-selection-control/base-selection-control.component";
import { KeyValuePipe, NgClass } from "@angular/common";
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import {QuestionUtils} from "../../../utils/question.utils";

@Component({
    selector: 'confirm-option-control',
    standalone: true,
    imports: [
        KeyValuePipe,
        NgbDropdown,
        NgbDropdownItem,
        NgbDropdownMenu,
        NgbDropdownToggle,
        NgClass
    ],
    templateUrl: './confirm-option-control.component.html',
    styleUrls: [
        './confirm-option-control.component.sass',
        '../base-input-control/base-input-control.component.sass',
        '../../base-form/base-form.component.sass'
    ],
    encapsulation: ViewEncapsulation.None
})
export class ConfirmOptionControl extends BaseSelectionControl implements OnInit, AfterViewInit {

    confirmButton = viewChild<ElementRef>("confirmButton");
    notConfirmButton = viewChild<ElementRef>("notConfirmButton");

    constructor() {
        super();

        this.inputType = 'confirm-option';
    }

    yesButton = 'confirmed';
    noButton = 'not-confirmed';

    override ngOnInit() {
        super.ngOnInit();

        const acceptedValues = this.question.acceptedValues;
        if (acceptedValues?.size === 2) {
            const keys = [...acceptedValues.keys()];
            this.yesButton = keys[0];
            this.noButton = keys[1];
        }
    }

    ngAfterViewInit() {
        if (this.editingResponse) {
            if (this.question.userResponse == this.yesButton) {
                this.confirmButton()?.nativeElement.focus();
            } else {
                this.notConfirmButton()?.nativeElement.focus();
            }
        }
    }

    override onValueChange(answer?: string) {
        this.control.setValue(answer);
        this.setModelValue(this.control.value);
    }

    buttonCode(code?: string, defaultCode = 'btn.ok'): string {
        if (this.question.type === 'CONFIRM_OPTION' && code) {
            return QuestionUtils.getOptionDisplayValue(this.baseForm.type, this.question, this.messages, code)
            // return `${this.baseForm.type}.option.${this.questionId}.${code.toLowerCase().replace(/[,:| ]/g, '')}`
        }
        return defaultCode;
    }
}
